'use strict';

var addressHelpers = require('./address');
var instorePickUpBase = require('instorepickup/checkout/shipping');
var formHelpers = require('core/checkout/formErrors');
var scrollAnimate = require('base/components/scrollAnimate');
var createErrorNotification = require('base/components/errorNotification');


function checkErrorMessage(response, attrs) {
    if (response.message) {
        var error = true;
        if (response.order.shipping.length > 0) {
            response.order.shipping.forEach(function (ship) {
                if (ship.shippingAddress && ship.shippingAddress.postalCode === attrs.postalCode.toString()) {
                    if (ship.applicableShippingMethods.length > 0) {
                        error = false;
                    }
                }
            });
        }
        if (error) {
            $('.error-message').show();
            $('.error-message-text').empty().append(response.message);
            scrollAnimate($('.error-message'));
        }
    }
}

/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(productLineItem, shipping, order, customer) {
    var uuidEl;
    var form;
    var $shippingAddressSelector;

    if (productLineItem) {
        uuidEl = $('input[value=' + productLineItem.UUID + ']');
        if (uuidEl && uuidEl.length > 0) {
            form = uuidEl[0].form;
            $shippingAddressSelector = $('.addressSelector', form);
        }
    } else {
        $shippingAddressSelector = $('#shipmentSelector-default');
    }

    var shippings = order.shipping;
    var hasSelectedAddress = false;

    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        $shippingAddressSelector.append(
            addressHelpers.methods.optionValueForAddress(null, false, order)
        );
        // Separator -
        $shippingAddressSelector.append(
            addressHelpers.methods.optionValueForAddress(
                order.resources.shippingAddresses,
                false,
                order,
                { className: 'multi-shipping' }
            )
        );

        shippings.forEach(function (aShipping) {
            if (
                !aShipping.selectedShippingMethod ||
                !aShipping.selectedShippingMethod.storePickupEnabled
            ) {
                var isSelected = shipping.UUID === aShipping.UUID;
                hasSelectedAddress = hasSelectedAddress || isSelected;

                var addressOption = addressHelpers.methods.optionValueForAddress(
                    aShipping,
                    isSelected,
                    order
                );
                var newAddress =
                    addressOption.html() === order.resources.addNewAddress;
                var matchingUUID = aShipping.UUID === shipping.UUID;
                if (
                    (newAddress && matchingUUID) ||
                    (!newAddress && matchingUUID) ||
                    (!newAddress && !matchingUUID)
                ) {
                    $shippingAddressSelector.append(addressOption);
                }
                if (newAddress && !matchingUUID) {
                    $(addressOption[0]).remove();
                }
            }
        });
        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(
                    order.resources.accountAddresses,
                    false,
                    order
                )
            );
            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress(
                        {
                            UUID: 'ab_' + address.ID,
                            shippingAddress: address
                        },
                        isSelected,
                        order
                    )
                );
            });
        }
    }

    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
    }
}

function getGA4Cookie(name) {
    var cookies = document.cookie.split("; ");

    for (var i = cookies.length - 1; i >= 0; i--) {
        var parts = cookies[i].split("=");

        if (parts[0] === name) {
            var value = decodeURIComponent(parts[1]);

            if (
                value &&
                value !== "deleted" &&
                (value.indexOf("GA") === 0 || value.indexOf("GS") === 0)
            ) {
                return value;
            }
        }
    }

    return null;
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues(shipping) {
    var addressObject = $.extend({}, shipping.shippingAddress);
    if (!shipping.shippingAddress) {
        addressObject = {
            firstName: $('#shipmentSelector-default option:selected').attr('data-first-name'),
            lastName: $('#shipmentSelector-default option:selected').attr('data-last-name'),
            address1: $('#shipmentSelector-default option:selected').attr('data-address1'),
            city: $('#shipmentSelector-default option:selected').attr('data-city'),
            postalCode: $('#shipmentSelector-default option:selected').attr('data-postal-code'),
            stateCode: $('#shipmentSelector-default option:selected').attr('data-state-code'),
            countryCode: '',
            phone: $('#shipmentSelector-default option:selected').attr('data-phone'),
            custom: {
                number: $('#shipmentSelector-default option:selected').attr('data-custom-number'),
                apartment: $('#shipmentSelector-default option:selected').attr('data-custom-apartment'),
                observation: $('#shipmentSelector-default option:selected').attr('data-custom-observation'),
                isnormalized: $('#shipmentSelector-default option:selected').attr('data-custom-isnormalized'),
                coordinates: $('#shipmentSelector-default option:selected').attr('data-custom-coordinates')
            }
        };
    }

    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;

        $('input[name$=_firstName]', form).val(addressObject.firstName);
        $('input[name$=_lastName]', form).val(addressObject.lastName);
        $('input[name$=_address1]', form).val(addressObject.address1);
        $('input[name$=_city]', form).val(addressObject.city);
        $('input[name$=_postalCode]', form).val(addressObject.postalCode);
        $('select[name$=_stateCode],input[name$=_stateCode]', form).val(
            addressObject.stateCode
        );
        if (addressObject.custom) {
            $('input[name$=_number]', form).val(addressObject.custom.number);
            $('input[name$=_apartment]', form).val(
                addressObject.custom.apartment || ''
            );
            $('input[name$=_observation]', form).val(
                addressObject.custom.observation || ''
            );
            if (addressObject.isNormalized) {
                $('input[name$=_isnormalized]', form).val(addressObject.isNormalized);
            }
            if (addressObject.coordinates) {
                $('input[name$=_coordinates]', form).val(addressObject.coordinates);
            }
        }
        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=_country]', form).val(
                addressObject.countryCode.value
            );
        } else {
            $('select[name$=_country]', form).val(addressObject.countryCode);
        }
        if (addressObject.phone) {
            $('input[name$=_phone]', form).val(addressObject.phone);
        }
        if (addressObject.phone) {
            $('input[name$=_phone]', form).val(addressObject.phone);
        }
        $('input[name$=_isGift]', form).prop('checked', addressObject.isGift);
        $('textarea[name$=_giftMessage]', form).val(
            addressObject.isGift && addressObject.giftMessage
                ? addressObject.giftMessage
                : ''
        );
    });

    $('body').trigger('shipping:updateShippingAddressFormValues', {
        shipping: shipping
    });
}

/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
    var uuidEl = $('input[value=' + shipping.UUID + ']');
    var shippingMethodMessages = $('[js-shipping-method-messages]');
    var $textExpress = shippingMethodMessages.find('.express-message').text();
    var $textNextDay = shippingMethodMessages.find('.next-day-message').text();
    if (uuidEl && uuidEl.length > 0) {
        $.each(uuidEl, function (shipmentIndex, el) {
            var form = el.form;
            if (!form) return;

            var $shippingMethodList = $('.shipping-method-list .col-12', form);

            if ($shippingMethodList && $shippingMethodList.length > 0) {
                $shippingMethodList.empty();
                var shippingMethods = shipping.applicableShippingMethods;

                shippingMethods.sort(function (a, b) {
                    return a.priceValue - b.priceValue;
                });

                var selected = shipping.selectedShippingMethod || {};
                var shippingMethodFormID =
                    form.name + '_shippingAddress_shippingMethodID';
                //
                // Create the new rows for each shipping method
                //
                $.each(shippingMethods, function (methodIndex, shippingMethod) {
                    var tmpl = $('#shipping-method-template').clone();
                    // set input
                    $('input', tmpl)
                        .prop(
                            'id',
                            'shippingMethod-' +
                                shippingMethod.ID +
                                '-' +
                                shipping.UUID
                        )
                        .prop('name', shippingMethodFormID)
                        .prop('value', shippingMethod.ID)
                        .attr('checked', shippingMethod.ID === selected.ID);
                    $('.row', tmpl).prop('id', (shippingMethod.ID).replace(/\s+/g, '-').toLowerCase());
                    if ((shippingMethod.ID).replace(/\s+/g, '-').toLowerCase() === 'clickandcollect' || (shippingMethod.ID).replace(/\s+/g, '-').toLowerCase() === 'pick-up' || (shippingMethod.ID).replace(/\s+/g, '-').toLowerCase() === 'storepickup') {
                        $('.row', tmpl).addClass('d-none');
                    }
                    $('label', tmpl).prop(
                        'for',
                        'shippingMethod-' +
                            shippingMethod.ID +
                            '-' +
                            shipping.UUID
                    );
                    // set shipping method name
                    $('.display-name', tmpl).text(shippingMethod.storefrontDisplayName);
                    if (shippingMethod.storefrontDisplayName === 'Express') {
                        $('.display-message', tmpl).text($textExpress);
                    }
                    if (shippingMethod.storefrontDisplayName === 'Next Day') {
                        $('.display-message', tmpl).text($textNextDay);
                    }
                    // set or hide arrival time
                    if (shippingMethod.estimatedArrivalTime) {
                        $('.arrival-time', tmpl)
                            .text(
                                '(' + shippingMethod.estimatedArrivalTime + ')'
                            )
                            .show();
                    }
                    // set shipping cost
                    $('.shipping-cost', tmpl).text(shippingMethod.shippingCost);
                    $shippingMethodList.append(tmpl.html());
                });
            }
        });
    }

    $('body').trigger('shipping:updateShippingMethods', { shipping: shipping });
}

function updateShippingNameText(selectedShippingMethod, $shippingAddressLabel, $shippingSummaryLabel) {
    var shippingMethodSelected = selectedShippingMethod.ID;
    switch (shippingMethodSelected) {
        case 'clickAndCollect':
            $shippingAddressLabel.text($(document).find('[name=clickAndCollectMethodId]').data('shippingname'));
            $shippingSummaryLabel.text($(document).find('[name=clickAndCollectMethodId]').data('methodname'));
            break;
        case 'storePickUp':
            $shippingAddressLabel.text($(document).find('[name=instorePickUpMethodId]').data('shippingname'));
            $shippingSummaryLabel.text($(document).find('[name=shipmentUUID]').data('methodname'));
            break;
        default:
            $shippingAddressLabel.text($(document).find('[name=shipmentUUID]').data('shippingname'));
            $shippingSummaryLabel.text($(document).find('[name=shipmentUUID]').data('methodname'));
            break;
    }
}

/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation(productLineItem, shipping, order, options) {
    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;

    if (!form) return;

    var $viewBlock = $('.view-address-block', form);
    var address = shipping.shippingAddress || {};
    var selectedMethod = shipping.selectedShippingMethod;
    var nameLine = address.firstName ? address.firstName + ' ' : '';

    if (address.lastName) nameLine += address.lastName;

    var address1Line = address.address1;
    var number = address.custom && address.custom.number ? address.custom.number : '';
    var phoneLine = address.phone;
    var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
    var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
    var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
        ? '(' + selectedMethod.estimatedArrivalTime + ')'
        : '';

    var tmpl = $('#pli-shipping-summary-template').clone();

    var numberTemplate = $('.ship-to-number', tmpl);

    $('.ship-to-name', tmpl).text(nameLine);
    numberTemplate.text(number);
    $('.ship-to-address1', tmpl).text(address1Line + ' ').append(numberTemplate);
    $('.ship-to-city-st-zip', tmpl).text(address.city + ', ' + (address.custom && address.custom.state ? address.custom.state : '') + ' ' + address.postalCode);
    $('.ship-to-phone', tmpl).text(phoneLine);

    if (!phoneLine) {
        $('.ship-to-phone', tmpl).hide();
    }

    if (shipping.selectedShippingMethod) {
        $('.display-name', tmpl).text(methodNameLine);
        $('.arrival-time', tmpl).text(methodArrivalTime);
        $('.price', tmpl).text(shippingCost);
    }

    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }
    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

    $viewBlock.html(tmpl.html());

    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
}


/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 */
function updateShippingMethodList($shippingForm, $zipCode) {
    formHelpers.clearPreviousErrors('.shipping-form');
    $('.success-message').hide();

    var $shippingMethodList = $shippingForm.find('.shipping-method-list');
    var urlParams = addressHelpers.methods.getAddressFieldsFromUI(
        $shippingForm
    );
    var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
    var url = $shippingMethodList.data('actionUrl');
    urlParams.shipmentUUID = shipmentUUID;

    $($zipCode).closest('.shipping-address-block')
        .siblings('.shipping-method-block')
        .find('.error-no-zip-code')
        .hide();
    if ($($zipCode).val() !== '') {
        $($zipCode).closest('.shipping-address-block').siblings('.shipping-method-block').removeClass('d-none');
    }

    $($zipCode).closest('.shipping-address-block').siblings('.shipping-method-block').find('.shipping-method-list')
        .show();

    if (urlParams.postalCode && urlParams.postalCode.length > 0) {
        $shippingMethodList.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    checkErrorMessage(data, urlParams);
                    $('body').trigger('checkout:updateCheckoutView', {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true }
                    });

                    $shippingMethodList.spinner().stop();
                }
            }
        });
    }
}

/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.shipping-phone');
        var $methodTitle = $container.find('.shipping-method-title');
        var $methodArrivalTime = $container.find(
            '.shipping-method-arrival-time'
        );
        var $methodPrice = $container.find('.shipping-method-price');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftSummary = $container.find('.gift-summary');

        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;

        addressHelpers.methods.populateAddressSummary(
            $addressContainer,
            address
        );

        if (address && address.phone) {
            $shippingPhone.text(address.phone);
        } else {
            $shippingPhone.empty();
        }

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText', {
                selectedShippingMethod: selectedShippingMethod,
                resources: order.resources,
                shippingAddressLabel: $shippingAddressLabel
            });
            updateShippingNameText(selectedShippingMethod, $shippingAddressLabel, $shippingSummaryLabel);
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            $methodTitle.text(selectedShippingMethod.storefrontDisplayName);
            if (selectedShippingMethod.estimatedArrivalTime) {
                $methodArrivalTime.text(
                    '( ' + selectedShippingMethod.estimatedArrivalTime + ' )'
                );
            } else {
                $methodArrivalTime.empty();
            }
            $methodPrice.text(selectedShippingMethod.shippingCost);
        }


        giftSummary
            .find('.gift')
            .prop('checked', isGift);
    });

    $('body').trigger('shipping:updateShippingSummaryInformation', {
        shipping: shipping,
        order: order
    });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            instorePickUpBase.methods.updateProductLineItemShipmentUUIDs(
                productLineItem,
                aShipping
            );
        });
    });

    // Now update shipping information, based on those associations
    instorePickUpBase.methods.updateShippingMethods(shipping);
    updateShippingAddressFormValues(shipping);
    updateShippingSummaryInformation(shipping, order);

    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(
            productLineItem,
            shipping,
            order,
            customer
        );
        updatePLIShippingSummaryInformation(
            productLineItem,
            shipping,
            order,
            options
        );
    });

    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options
    });
}

/**
 * Clear out all the shipping form values and select the new address in the drop down
 * @param {Object} order - the order object
 */
function clearShippingForms(order) {
    order.shipping.forEach(function (shipping) {
        $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
            var form = el.form;
            if (!form) return;

            $('input[name$=_firstName]', form).val('');
            $('input[name$=_lastName]', form).val('');
            $('input[name$=_address1]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_city]', form).val('');
            $('input[name$=_number]', form).val('');
            $('input[name$=_apartment]', form).val('');
            $('input[name$=_observation]', form).val('');
            $('input[name$=_postalCode]', form).val('');
            $('select[name$=_stateCode],input[name$=_stateCode]', form).val('');
            $('select[name$=_country]', form).val('');

            $('input[name$=_phone]', form).val('');

            $('input[name$=_isGift]', form).prop('checked', false);
            $('textarea[name$=_giftMessage]', form).val('');
            $(form).find('.gift-message').addClass('d-none');

            $(form).attr('data-address-mode', 'new');
            var addressSelectorDropDown = $(
                '.addressSelector option[value=new]',
                form
            );
            $(addressSelectorDropDown).prop('selected', true);
        });
    });

    $('body').trigger('shipping:clearShippingForms', { order: order });
}

instorePickUpBase.methods.updateShippingAddressSelector = updateShippingAddressSelector;
instorePickUpBase.methods.updateShippingAddressFormValues = updateShippingAddressFormValues;
instorePickUpBase.methods.updateShippingMethods = updateShippingMethods;
instorePickUpBase.methods.updateShippingMethodList = updateShippingMethodList;
instorePickUpBase.methods.updateShippingSummaryInformation = updateShippingSummaryInformation;
instorePickUpBase.methods.updateShippingInformation = updateShippingInformation;
instorePickUpBase.methods.clearShippingForms = clearShippingForms;
instorePickUpBase.methods.updatePLIShippingSummaryInformation = updatePLIShippingSummaryInformation;
instorePickUpBase.methods.updateShippingAddressSelector = updateShippingAddressSelector;


instorePickUpBase.selectSingleShipAddress = function () {
    $('.single-shipping .addressSelector').on('change', function () {
        var form = $(this).parents('form')[0];
        var selectedOption = $('option:selected', this);
        var attrs = selectedOption.data();
        var shipmentUUID = selectedOption[0].value;
        var originalUUID = $('input[name=shipmentUUID]', form).val();
        var element;
        Object.keys(attrs).forEach(function (attr) {
            element = attr === 'countryCode' ? 'country' : attr;
            if (attr.includes('custom')) {
                element = attr.replace('custom', '').toLowerCase();
            }
            // check if variable is an object, in order to stringify it
            if (typeof attrs[attr] === 'object' && !Array.isArray(attrs[attr])) {
                $('[name$=' + element + ']', form).val(JSON.stringify(attrs[attr]));
            } else {
                $('[name$=' + element + ']', form).val(attrs[attr]);
            }
        });
        $('[name$=postalCode]', form).trigger('change');
        if (shipmentUUID === '') {
            $(form).attr('data-address-mode', 'new');
        } else if (shipmentUUID === originalUUID) {
            $(form).attr('data-address-mode', 'shipment');
        } else if (shipmentUUID.indexOf('ab_') === 0) {
            $(form).attr('data-address-mode', 'customer');
        } else {
            $(form).attr('data-address-mode', 'edit');
        }
    });
};


instorePickUpBase.selectMultiShipAddress = function () {
    var baseObj = this;

    $('.multi-shipping .addressSelector').on('change', function () {
        var form = $(this).closest('form');
        var selectedOption = $('option:selected', this);
        var attrs = selectedOption.data();
        var shipmentUUID = selectedOption[0].value;
        var originalUUID = $('input[name=shipmentUUID]', form).val();
        var pliUUID = $('input[name=productLineItemUUID]', form).val();
        var createNewShipmentScoped = baseObj.methods && baseObj.methods.createNewShipment ? baseObj.methods.createNewShipment : createNewShipment;

        formHelpers.clearPreviousErrors('.shipping-form');
        $('.success-message').hide();

        $('.shipping-method-list', form).show();
        $('.error-no-zip-code', form).hide();

        var element;
        Object.keys(attrs).forEach(function (attr) {
            if (attr === 'isGift') {
                $('[name$=' + attr + ']', form).prop('checked', attrs[attr]);
                $('[name$=' + attr + ']', form).trigger('change');
            } else {
                element = attr === 'countryCode' ? 'country' : attr;
                if (attr.includes('custom')) {
                    element = attr.replace('custom', '').toLowerCase();
                }
                $('[name$=' + element + ']', form).val(attrs[attr]);
            }
        });

        if (shipmentUUID === 'new' && pliUUID) {
            var createShipmentUrl = $(this).attr('data-create-shipment-url');
            createNewShipmentScoped(createShipmentUrl, { productLineItemUUID: pliUUID })
                .done(function (response) {
                    $.spinner().stop();
                    if (response.error) {
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                        return;
                    }

                    checkErrorMessage(response, attrs);


                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: response.order,
                            customer: response.customer,
                            options: { keepOpen: true }
                        }
                    );

                    $(form).attr('data-address-mode', 'new');
                })
                .fail(function () {
                    $.spinner().stop();
                });
        } else if (shipmentUUID === originalUUID) {
            $('select[name$=postalCode]', form).trigger('change');
            $(form).attr('data-address-mode', 'shipment');
        } else if (shipmentUUID.indexOf('ab_') === 0) {
            var url = $(form).attr('action');
            var serializedData = $(form).serialize();
            createNewShipmentScoped(url, serializedData)
                .done(function (response) {
                    $.spinner().stop();
                    if (response.error) {
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                        return;
                    }

                    checkErrorMessage(response, attrs);

                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: response.order,
                            customer: response.customer,
                            options: { keepOpen: true }
                        }
                    );

                    $(form).attr('data-address-mode', 'customer');
                    var $rootEl = $(form).closest('.shipping-content');
                    if (baseObj.methods && baseObj.methods.editMultiShipAddress) {
                        baseObj.methods.editMultiShipAddress($rootEl);
                    } else {
                        editMultiShipAddress($rootEl);
                    }
                })
                .fail(function () {
                    $.spinner().stop();
                });
        } else {
            var updatePLIShipmentUrl = $(form).attr('action');
            var serializedAddress = $(form).serialize();
            createNewShipmentScoped(updatePLIShipmentUrl, serializedAddress)
                .done(function (response) {
                    $.spinner().stop();
                    if (response.error) {
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                        return;
                    }

                    checkErrorMessage(response, attrs);

                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: response.order,
                            customer: response.customer,
                            options: { keepOpen: true }
                        }
                    );

                    $(form).attr('data-address-mode', 'edit');
                })
                .fail(function () {
                    $.spinner().stop();
                });
        }
    });
};

// select state functionality
var pickStoreRadio = $('#instorePickUpMethodCheck');
var correoRadio = $('#correoArgPickUpMethodCheck');
var storeTab = $('#pickUpStoresSearch');
var correoTab = $('#pickUpCorreoArgentinoSearch');

pickStoreRadio.on('change', function () {
    correoTab.addClass('d-none');
    storeTab.removeClass('d-none');
});

correoRadio.on('change', function () {
    correoTab.removeClass('d-none');
    storeTab.addClass('d-none');
});

instorePickUpBase.saveMultiShipInfo = function () {
    $('.btn-save-multi-ship').on('click', function (e) {
        e.preventDefault();
        var validateBtn = $(this);
        // Save address to checkoutAddressBook
        var form = $(this).closest('form');
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI(
            form
        );
        var $rootEl = $(this).closest('.shipping-content');
        var url = $(form).attr('action');
        var checkedShippingMethod = $('input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked', form);
        var isStorePickUpMethod = checkedShippingMethod.attr('data-pickup');
        var storeId = $("input[name='storeId']", form).val();
        var errorMsg = 'Before you can continue to the next step, you must select a store.';

        if (storeId) {
            form.find('[name=shipmentSelector]').val('');
        }

        var data = $(form).serialize();
        data += '&isMultiShipValidation=true';
        if (isStorePickUpMethod === 'true' && (storeId === undefined)) {
            instorePickUpBase.methods.createErrorNotification(errorMsg);
        } else {
            $rootEl.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data
            })
                .done(function (response) {
                    formHelpers.clearPreviousErrors(form);
                    if (response.error || response.message) {
                        if (response.error) {
                            if (response.fieldErrors && response.fieldErrors.length) {
                                response.fieldErrors.forEach(function (error) {
                                    if (Object.keys(error).length) {
                                        formHelpers.loadFormErrors(form, error);
                                    }
                                });
                            } else if (response.serverErrors && response.serverErrors.length) {
                                $.each(response.serverErrors, function (index, element) {
                                    instorePickUpBase.methods.createErrorNotification(element);
                                });
                            }
                        } else {
                            checkErrorMessage(response, urlParams);
                        }
                        $('button.submit-shipping').attr('disabled', true);
                    } else {
                        // Update UI from response
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer
                            }
                        );

                        instorePickUpBase.methods.viewMultishipAddress($rootEl);
                        validateBtn.addClass('validated');
                        validateBtn.removeClass('validate');
                        validateBtn.removeClass('d-none');
                        $('button.submit-shipping').attr('disabled', null);
                    }
                    if (response.order && response.order.shippable) {
                        $('button.submit-shipping').attr('disabled', null);
                    }

                    $rootEl.spinner().stop();
                })
                .fail(function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }

                    $rootEl.spinner().stop();
                });
        }
        return false;
    });
};
instorePickUpBase.cancelShippingForm = function () {
    $('.cancel-new-shipping-address').on('click', function () {
        var form = $('#dwfrm_shipping');
        $('input[name$=_firstName]', form).val('');
        $('input[name$=_lastName]', form).val('');
        $('input[name$=_address1]', form).val('');
        $('input[name$=_city]', form).val('');
        $('input[name$=_number]', form).val('');
        $('input[name$=_apartment]', form).val('');
        $('input[name$=_observation]', form).val('');
        $('input[name$=_postalCode]', form).val('');
        $('select[name$=_stateCode],input[name$=_stateCode]', form).val('');
        $('select[name$=_country]', form).val('');

        $('input[name$=_phone]', form).val('');

        $('input[name$=_isGift]', form).prop('checked', false);
        $('textarea[name$=_giftMessage]', form).val('');
        $(form).find('.gift-message').addClass('d-none');

        $(form).attr('data-address-mode', 'new');
        var addressBook = $('.addressSelector option[value=address-book]', form);
        var select = $('shipment-selector-block', form);

        if (!select.hasClass('d-none')) {
            addressBook.next().prop('selected', 'selected');

            form.attr(
                'data-address-mode',
                'customer'
            );
            addressBook.parent().trigger('change');
        }
    });
};
instorePickUpBase.selectShippingMethod = function () {
    var baseObj = this;
    $('.instore-pick-up-tab').on('click', function () {
        $('#instorePickUpMethodCheck').trigger('click');
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=instorePickUpMethodId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.currentBasketEliminateCCStores = true;
        $('.button-new-address-custom').removeClass('d-none');
        var url = $('.shipping-method-list').data('select-shipping-method-url');
        var radioButtonShippingInstoreMethod = $('#shipping-method-instore');
        var checkedRadioInstoreValue = radioButtonShippingInstoreMethod.is(':checked');
        if (checkedRadioInstoreValue) {
            radioButtonShippingInstoreMethod.prop('checked', false);
            $('button.submit-shipping').attr('disabled', true);
        } else {
            radioButtonShippingInstoreMethod.prop('checked', true);
        }
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
        $shippingForm.find('.selected-store-header i.fa-trash').trigger('click');
    });

    $('.cc-tab').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=clickAndCollectMethodId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;

        var url = $('.shipping-method-list').data('select-shipping-method-url');
        var radioButtonShippingInstoreMethod = $('#shipping-method-cc');

        radioButtonShippingInstoreMethod.is(':checked') ? radioButtonShippingInstoreMethod.prop('checked', false) : radioButtonShippingInstoreMethod.prop('checked', true);

        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
        $shippingForm.find('.selected-store-header i.fa-trash').trigger('click');
    });

    $('#instorePickUpMethodCheck').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=instorePickUpMethodId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.currentBasketEliminateCCStores = true;

        var url = $('.shipping-method-list').data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
        $shippingForm.find('.selected-store-header i.fa-trash').trigger('click');
    });

    $('#correoArgPickUpMethodCheck').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=correoArgentinoMethodId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.currentBasketEliminateCCStores = true;

        var url = $('.shipping-method-list').data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
    });

    $('.correoarg-pick-up-tab').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=correoArgentinoMethodId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.currentBasketEliminateCCStores = true;
        var radioButtonShippingCorreoMethod = $('#shipping-method-correoarg');
        var checkedRadioCorreoargValue = radioButtonShippingCorreoMethod.is(':checked');

        if (checkedRadioCorreoargValue) {
            radioButtonShippingCorreoMethod.prop('checked', false);
            $('button.submit-shipping').attr('disabled', true);
        } else {
            radioButtonShippingCorreoMethod.prop('checked', true);
        }
        var url = $('.shipping-method-list').data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
        $shippingForm.find('.selected-store-header i.fa-trash').trigger('click');
        $('#pickItStoresObject').val('');
    });

    // PickIt methodId
    $('.pick-it-tab').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(this).attr('value');
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        var radioButtonShippingCorreoMethod = $('#shipping-method-pickit');
        var checkedRadioCorreoargValue = radioButtonShippingCorreoMethod.is(':checked');

        if (checkedRadioCorreoargValue) {
            radioButtonShippingCorreoMethod.prop('checked', false);
            $('button.submit-shipping').attr('disabled', true);
        } else {
            radioButtonShippingCorreoMethod.prop('checked', true);
        }
        var url = $('.shipping-method-list').data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
        $shippingForm.find('.selected-store-header i.fa-trash').trigger('click');
        $('#correoArgentinoAgenciesObject').val('');
    });

    $('.first-tab').on('click', function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(document).find('[name=defaultShippingMethodsId]').val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = {
            custom: {}
        };
        urlParams.methodID = methodID;
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.currentBasketEliminateCCStores = true;
        var radioButtonShippingDeliveryMethod = $('#shipping-method-delivery');
        var checkedRadioDeliveryValue = radioButtonShippingDeliveryMethod.is(':checked');
        if (checkedRadioDeliveryValue) {
            radioButtonShippingDeliveryMethod.prop('checked', false);
            $('button.submit-shipping').attr('disabled', true);
        } else {
            radioButtonShippingDeliveryMethod.prop('checked', true);
        }
        var url = $('.shipping-method-list').data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, null);
        } else {
            selectShippingMethodAjax(url, urlParams, null);
        }
    });

    $('.shipping-method-list').change(function () {
        var $shippingForm = $(this).parents('form');
        var methodID = $(':checked', this).val();
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI(
            $shippingForm
        );
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.methodID = methodID;
        urlParams.currentBasketEliminateCCStores = true;
        urlParams.isGift = $shippingForm.find('.gift').prop('checked');
        urlParams.giftMessage = $shippingForm
            .find('textarea[name$=_giftMessage]')
            .val();

        var url = $(this).data('select-shipping-method-url');
        if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
            baseObj.methods.selectShippingMethodAjax(url, urlParams, $(this));
        } else {
            selectShippingMethodAjax(url, urlParams, $(this));
        }
    });
};
instorePickUpBase.updateShippingList = function () {
    var baseObj = this;

    $('input[name$="shippingAddress_addressFields_postalCode"]').on(
        'change',
        function (e) {
            var currentStage = $('.data-checkout-stage').data('checkout-stage');
            if (currentStage === 'shipping') {
                if (baseObj.methods && baseObj.methods.updateShippingMethodList) {
                    baseObj.methods.updateShippingMethodList(
                        $(e.currentTarget.form),
                        this
                    );
                } else {
                    updateShippingMethodList($(e.currentTarget.form), this);
                }
            }
        }
    );
};

function scrollFieldPaymentForm() {
    $(document).ready(function () {
        const scrollOffset = 10;
        const requiredInputs = $(
            "#dwfrm_billing .billing-address-block :input[required]"
        );
        const firstEmptyInput = requiredInputs
            .filter(function () {
                return !$(this).val().trim();
            })
            .first();

        if (firstEmptyInput.length) {
            // Si hay campos obligatorios vacíos, hacer scroll al primer input obligatorio
            const targetOffset = firstEmptyInput.offset().top - scrollOffset;
            $("html, body").animate({ scrollTop: targetOffset }, 500);
        } else {
            // Si no hay campos vacíos, hacer scroll a la sección de pago
            scrollAnimate($(".payment-form"));
        }
    });
}

instorePickUpBase.methods.shippingFormResponse = function (defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });

            /* DAB-2220 - BEGIN */
            $(formSelector + ' .btn-show-details').click();
            /* DAB-2220 - END */

            defer.reject(data);
        }

        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                createErrorNotification('error-message-text', element);
            });

            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        // Populate the Address Summary

        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        setTimeout(() => {
            scrollFieldPaymentForm();
        }, 500);
        defer.resolve(data);
    }
};

instorePickUpBase.cancelMultiShipAddress = function () {
    var baseObj = this;

    $('.btn-cancel-multi-ship-address').on('click', function (e) {
        e.preventDefault();

        var form = $(this).closest('form');
        var $rootEl = $(this).closest('.shipping-content');
        var restoreState = $rootEl.data('saved-state');

        // Should clear out changes / restore previous state
        if (restoreState) {
            var restoreStateObj = JSON.parse(restoreState);
            var originalStateCode = restoreStateObj.shippingAddress.stateCode;
            var stateCode = $('[name$=_stateCode]', form).val();

            updateShippingAddressFormValues(restoreStateObj);

            if (stateCode !== originalStateCode) {
                $('[data-action=save]', form).trigger('click');
            } else {
                $(form).attr('data-address-mode', 'edit');
                if (baseObj.methods && baseObj.methods.editMultiShipAddress) {
                    baseObj.methods.editMultiShipAddress($rootEl);
                } else {
                    editMultiShipAddress($rootEl);
                }
            }
        }

        return false;
    });
};

// This fix a bug with bootstrap and multiple tabs. DO NOT change tabs attrs
$('[id$="-tab"]').on('click', function () {
    if (!this.id.includes('instore-form-')) {
        $('.selected-store-header i.fa-trash').click();
    } else if (this.classList.contains('active')) {
        e.preventDefault();
        return;
    }
    const id = this.id.split('instore-form-').filter(a => a)[0].split('-tab')[0];
    const content = $('#' + id);
    content.addClass('active');
    content.siblings().removeClass('active');
});

$('.cancel-new-shipping-address').each(function () {
    $(this).on('click', function () {
        $('.shipping-address-block[data-product-id="' + this.dataset.productId + '"]').hide();
        $('.btn-add-new[data-product-id="' + this.dataset.productId + '"]').show();
        $('.btn-save-multi-ship.save-shipment.address-validation-btn[data-product-id="' + this.dataset.productId + '"]').addClass('d-none');
        $('#shipmentSelector-default').removeClass('d-none');
        var form = $(this).closest('form');
        var selected = $(`#shipmentSelector-${this.dataset.productId || 'default'}`).children('option:selected');
        var label = selected[0] ? selected[0].label : 'Dirección Nueva';
        if (selected.length > 0 && label !== 'Dirección Nueva') {
            $('.shipping-method-list', form).show();
            $('.error-no-zip-code', form).hide();
        } else {
            $('.shipping-method-list', form).hide();
            $('.error-no-zip-code', form).show();
        }
    });
});

$('.btn-add-new').on('click', function () {
    $('.shipping-address-block[data-product-id="' + this.dataset.productId + '"]').show();
    var validateBtn = $('.btn-save-multi-ship.save-shipment.address-validation-btn[data-product-id="' + this.dataset.productId + '"]');
    validateBtn.removeClass('d-none');
    validateBtn.removeClass('validated');
    validateBtn.addClass('validate');

    var form = $(this).closest('form');
    $('.shipping-method-list', form).hide();
    $('.error-no-zip-code', form).show();
});

// Enable Submit Shipping Button whenm shippingForm is completed
$('.shipping-form-custom .form-control').on('keyup change', function () {
    const $input = $(this);
    const $form = $('.shipping-form-custom');

    if ($input.val().trim() !== '') {
        $input.removeClass('is-invalid');
        $input.closest('.invalid-feedback').empty();
    }

    if ($form.find('.is-invalid').length === 0) {
        $('body').trigger('checkout:enableButton', 'button.submit-shipping');
    }
});

$('.btn.submit-shipping').on('click', function (e) {
    // $('.multi-ship .btn.btn-save-multi-ship.save-shipment.address-validation-btn').each(function () {
    //     if (!$(this).hasClass('validated') && this.dataset.productId !== 'null') {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         $('.error-message').show();
    //         $('.error-message-title').text('Dirección(es) no validada(s)');
    //         $('.error-message-text').text('Es necesario que valides todas las direcciones de envío para poder pasar al próximo paso del Checkout.');
    //         scrollAnimate($('.error-message'));
    //     }
    // });
    $('.btn.save-shipment.address-validation-btn').each(function () {
        if (!$(this).hasClass('validated') && this.dataset.productId !== 'null') {
            $('.shipping-form-custom').removeClass('d-none');
            $('.button-new-address-custom').addClass('d-none');
            $('#dwfrm_shipping').attr('data-address-mode', 'edit');
            // e.preventDefault();
            // e.stopPropagation();
            $('.error-message').show();
            $('.error-message-title').text('Dirección(es) no validada(s)');
            $('.error-message-text').text('Es necesario que valides todas las direcciones de envío para poder pasar al próximo paso del Checkout.');
            scrollAnimate($('.error-message'));
        }
    });
});

$('.form-control').on('change', function (e) {
    var validateBtn = $('.btn-save-multi-ship.save-shipment.address-validation-btn[data-product-id="' + this.dataset.productId + '"]');
    validateBtn.removeClass('validated');
    validateBtn.addClass('validate');
});

$('.btn.submit-shipping').each(function () {
    instorePickUpBase.methods.updateMultiShipInformation = function (order) {
        var $checkoutMain = $('#checkout-main');
        var $checkbox = $('[name=usingMultiShipping]');
        var $submitShippingBtn = $('button.submit-shipping');
        $('.shipping-error .alert-danger').remove();

        if (order.usingMultiShipping) {
            if (!$checkoutMain.hasClass('multi-ship')) {
                $checkoutMain.addClass('multi-ship');
                $checkbox.prop('checked', true);

                var plis = $('[name="productLineItemUUID"]');
                for (var i = 0; i < plis.length; i++) {
                    var form = plis[i].form;
                    var selected = $('#shipmentSelector-' + plis[i].value).children('option:selected');
                    var label = selected[0].label;
                    if (selected.length > 0 && label !== 'Dirección Nueva') {
                        $('.shipping-method-list', form).show();
                        $('.error-no-zip-code', form).hide();
                    } else {
                        $('.shipping-method-list', form).hide();
                        $('.error-no-zip-code', form).show();
                    }
                }
            }
        } else {
            $checkoutMain.removeClass('multi-ship');
            $checkbox.prop('checked', null);
            var radioButtonShippingDeliveryMethod = $('#shipping-method-delivery');
            var checkedRadioDeliveryValue = radioButtonShippingDeliveryMethod.is(':checked');
            var radioButtonShippingCorreoMethod = $('#shipping-method-correoarg');
            var checkedRadioCorreoargValue = radioButtonShippingCorreoMethod.is(':checked');
            var radioButtonShippingInstoreMethod = $('#shipping-method-instore');
            var checkedRadioInstoreValue = radioButtonShippingInstoreMethod.is(':checked');
            var radioButtonShippingCC = $('#shipping-method-cc');
            var checkedRadioCC = radioButtonShippingCC.is(':checked');
            var radioButtonShippingPickItMethod = $('#shipping-method-pickit');
            var checkedRadioPickItValue = radioButtonShippingPickItMethod.is(':checked');

            if (!checkedRadioDeliveryValue && !checkedRadioCorreoargValue && !checkedRadioInstoreValue && !checkedRadioCC && !checkedRadioPickItValue) {
                $submitShippingBtn.prop('disabled', true);
            } else {
                $submitShippingBtn.prop('disabled', false);
            }

            var defaultSelector = $('#shipmentSelector-default');
            var addressBlock = defaultSelector.parents('.shipment-selector-block');
            addressBlock.removeClass('d-none');
        }

        $('body').trigger('shipping:updateMultiShipInformation', { order: order });
    };
});

instorePickUpBase.isGift = function () {
    $('.gift').on('change', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var validateBtn = $(form).find('.btn-save-multi-ship');
        validateBtn.addClass('validate');
        validateBtn.removeClass('validated');
    });
};

instorePickUpBase.scrollFieldPaymentForm = scrollFieldPaymentForm;
instorePickUpBase.getGA4Cookie = getGA4Cookie;
module.exports = instorePickUpBase;